export const COMPATS_WIDGET_BLOCK = 'compats_widget_block';
export const COMPATS_WIDGET_STICKY = 'compats_widget_sticky';
export const COMPOSED_HIGHLIGHT = 'composed_highlight';
export const COOKIE_AUTOCOMPLETE = 'backend_dejavu_info';
export const COMPATS_MESSAGE = 'COMPATS_MESSAGE';
export const COMPATS_CUSTOM = 'COMPATS_CUSTOM';
export const COMPATS_MESSAGE_TOP = 'COMPATS_MESSAGE_TOP';
export const COMPATS_COMPLETE = 'COMPLETE';
